import 'babel-polyfill'
import Vue from 'vue'
import store from './store'
import Modal from './component/modal/modal.vue'

Vue.config.productionTip = false


/* eslint-disable no-new */
window.vue = new Vue({
  el: '#vue-modal-component',
  // eslint-disable-next-line no-irregular-whitespace
  store,
  // eslint-disable-next-line no-irregular-whitespace
  components: { Modal },
	created () {
		// eslint-disable-next-line no-undef
    	if(OPED.login_user) {
			this.$store.state.userData.last_name = OPED.login_user.last_name;
			this.$store.state.userData.first_name = OPED.login_user.first_name;
			this.$store.state.userData.phone = OPED.login_user.phone;
			this.$store.state.userData.email = OPED.login_user.email;
			this.$store.state.userData.birthday = OPED.login_user.birthday;
			this.$store.state.userData.gender = OPED.login_user.gender;
			this.$store.state.userData.plan = OPED.login_user.plan_class;
			this.$store.state.userData.mm01 = OPED.login_user.mm01;
			this.$store.state.userData.mm02 = OPED.login_user.mm02;
		}
	},
	template: '<Modal />',
})

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}



// WEBPACK FOOTER //
// ./resources/assets/js/vue/app.js